import React from 'react';
import clsx from 'clsx';

export function Skeleton({ className, ...props }) {
  return (
    <div
      className={clsx(
        'bg-slate-200 rounded animate-pulse',
        className
      )}
      {...props}
    />
  );
}
